import { Trans } from "@lingui/macro"
import { Button } from "@silversea-ssc/ui-components-react"
import React from "react"
import styles from "./InfographicExpandButton.module.scss"

type Props = {
    onToggleFareCardExpandClick?: () => void
    isExpanded: boolean
}

const InfographicExpandButton: React.FC<Props> = ({ onToggleFareCardExpandClick, isExpanded }) => {
    return (
        <div className={styles.buttonWrapper}>
            <Button
                renderAs="button"
                variant="inline-text"
                onClick={onToggleFareCardExpandClick}
                dataContentPiece="expand_fare_card"
                iconName={isExpanded ? "chevron-up" : "chevron-down"}
                noWrap
                full
                className={styles.button}
                disabled={!onToggleFareCardExpandClick}
            >
                {isExpanded ? <Trans>View less info</Trans> : <Trans>View more info</Trans>}
            </Button>
        </div>
    )
}

export default InfographicExpandButton
